import * as React from 'react';
import { Paper, Typography } from "@mui/material";
import Zoom from '@mui/material/Zoom';

export const PopupViewSafeZone = ({ item }) => {
    const [transitionIn, setTransitionIn] = React.useState(false)

    React.useEffect(() => {
        setTransitionIn(false)
        const key = setTimeout(() => {  
            setTransitionIn(true)
        }, 400);

        return () => clearTimeout(key)
    }, [item.id])

    return (
        <Zoom in={transitionIn} timeout={300} easing={{ enter: "ease-out", exit: "ease-in" }}>
            <div className='gisPopup'>
                <div className='popTit'>노인보호구역</div>
                <div className='popConts' style={{display: "grid", gridTemplateColumns: "0.6fr 1fr", gap: "12px", fontSize: "20px"}}>                    
                    <div className='subTxt'>이름</div>
                    <div>{item.nm}</div>
                </div>
            </div>
        </Zoom>
    )
}